var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactiveWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2128 0.755324C11.7343 0.672717 12.2657 0.672717 12.7872 0.755324L14.8806 1.08689C15.4022 1.16949 15.9075 1.33368 16.378 1.57341L18.2665 2.53564C18.737 2.77538 19.1668 3.08768 19.5402 3.46107L21.0389 4.95978C21.4123 5.33318 21.7246 5.76302 21.9644 6.23353L22.9266 8.12201C23.1663 8.59251 23.3305 9.09782 23.4131 9.61938L23.7447 11.7128C23.8273 12.2343 23.8273 12.7657 23.7447 13.2872L23.4131 15.3806C23.3305 15.9022 23.1663 16.4075 22.9266 16.878L21.9644 18.7665C21.7246 19.237 21.4123 19.6668 21.0389 20.0402L19.5402 21.5389C19.1668 21.9123 18.737 22.2246 18.2665 22.4644L16.378 23.4266C15.9075 23.6663 15.4022 23.8305 14.8806 23.9131L12.7872 24.2447C12.2657 24.3273 11.7343 24.3273 11.2128 24.2447L9.11938 23.9131C8.59782 23.8305 8.09251 23.6663 7.62201 23.4266L5.73353 22.4644C5.26302 22.2246 4.83318 21.9123 4.45978 21.5389L2.96107 20.0402C2.58768 19.6668 2.27538 19.237 2.03564 18.7665L1.07341 16.878C0.833678 16.4075 0.669493 15.9022 0.586886 15.3806L0.255324 13.2872C0.172717 12.7657 0.172717 12.2343 0.255324 11.7128L0.586886 9.61938C0.669493 9.09782 0.833678 8.59251 1.07341 8.12201L2.03564 6.23353C2.27538 5.76302 2.58768 5.33318 2.96107 4.95978L4.45978 3.46107C4.83318 3.08768 5.26302 2.77538 5.73353 2.53564L7.62201 1.57341C8.09251 1.33368 8.59782 1.16949 9.11938 1.08689L11.2128 0.755324Z",
    fill: "#FFE6BF",
    stroke: "#F9CD8C",
    strokeWidth: 0.258065
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5566 11.6875H12.2341V16.1956",
    stroke: "#F59D18",
    strokeWidth: 1.04839,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3203 16.2998H13.9372",
    stroke: "#F59D18",
    strokeWidth: 1.04839,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1297 10.1149C11.9638 10.1149 11.8017 10.0657 11.6638 9.97357C11.5258 9.88141 11.4183 9.75042 11.3549 9.59717C11.2914 9.44392 11.2748 9.27528 11.3071 9.11259C11.3395 8.94989 11.4194 8.80045 11.5367 8.68315C11.654 8.56586 11.8034 8.48598 11.9661 8.45362C12.1288 8.42125 12.2974 8.43786 12.4507 8.50134C12.6039 8.56482 12.7349 8.67232 12.8271 8.81025C12.9192 8.94817 12.9684 9.11033 12.9684 9.27621C12.9684 9.49865 12.8801 9.71198 12.7228 9.86927C12.5655 10.0266 12.3522 10.1149 12.1297 10.1149Z",
    fill: "#F59D18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveWalletIcon);
export default __webpack_public_path__ + "static/media/inactive-wallet-icon.da1a71d1df61eefd8f6c3e3adc9dd529.svg";
export { ForwardRef as ReactComponent };